import React from 'react';
import { IIconProps, IconHeight, IconSizes, IconWidth } from './type';

interface IVisibilityOffProps extends IIconProps {
  width?: number;
  height?: number;
}

const VisibilityOff: React.FC<IVisibilityOffProps> = ({
  size = IconSizes.lg,
  width,
  height,
  color = '#000',
  UNSAFE_className,
  ...props
}) => {
  return (
    <svg
      viewBox="0 0 32 32"
      width={width || IconWidth[size]}
      height={height || IconHeight[size]}
      color={color}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={UNSAFE_className || ''}
      {...props}
    >
      <path
        d="M21.0333 17.2999L19.5333 15.7999C19.7333 14.6888 19.4169 13.6946 18.584 12.8173C17.7502 11.9391 16.7333 11.5999 15.5333 11.7999L14.0333 10.2999C14.3444 10.1666 14.6555 10.0666 14.9667 9.99994C15.2778 9.93328 15.6222 9.89994 16 9.89994C17.5111 9.89994 18.7942 10.4279 19.8493 11.4839C20.9053 12.5391 21.4333 13.8222 21.4333 15.3333C21.4333 15.7111 21.4 16.0608 21.3333 16.3826C21.2667 16.7053 21.1667 17.0111 21.0333 17.2999ZM25.2667 21.4333L23.8 20.0666C24.6444 19.4222 25.3947 18.7164 26.0507 17.9493C26.7058 17.1831 27.2667 16.3111 27.7333 15.3333C26.6222 13.0888 25.0275 11.3053 22.9493 9.98261C20.872 8.66083 18.5555 7.99994 16 7.99994C15.3555 7.99994 14.7222 8.04439 14.1 8.13328C13.4778 8.22217 12.8667 8.3555 12.2667 8.53328L10.7 6.96661C11.5444 6.63328 12.4058 6.38883 13.284 6.23328C14.1613 6.07772 15.0667 5.99994 16 5.99994C19.1333 5.99994 21.9555 6.86128 24.4667 8.58394C26.9778 10.3057 28.8 12.5555 29.9333 15.3333C29.4444 16.5333 28.8111 17.6497 28.0333 18.6826C27.2555 19.7164 26.3333 20.6333 25.2667 21.4333ZM26.3333 29.1666L20.9667 23.7999C20.2778 24.0666 19.5169 24.2777 18.684 24.4333C17.8502 24.5888 16.9555 24.6666 16 24.6666C12.8667 24.6666 10.0498 23.8053 7.54932 22.0826C5.04976 20.3608 3.22221 18.1111 2.06665 15.3333C2.55554 14.1555 3.18887 13.0555 3.96665 12.0333C4.74443 11.0111 5.59998 10.1333 6.53332 9.39994L2.83332 5.66661L4.23332 4.23328L27.7667 27.7666L26.3333 29.1666ZM7.93332 10.7999C7.22221 11.3555 6.5391 12.0279 5.88398 12.8173C5.22798 13.6057 4.68887 14.4444 4.26665 15.3333C5.37776 17.5777 6.97198 19.3608 9.04932 20.6826C11.1275 22.0053 13.4444 22.6666 16 22.6666C16.6 22.6666 17.2 22.6164 17.8 22.5159C18.4 22.4164 18.9111 22.3111 19.3333 22.1999L17.6667 20.4666C17.4222 20.5555 17.1555 20.6275 16.8666 20.6826C16.5778 20.7386 16.2889 20.7666 16 20.7666C14.4889 20.7666 13.2058 20.2386 12.1507 19.1826C11.0947 18.1275 10.5667 16.8444 10.5667 15.3333C10.5667 15.0666 10.5947 14.7831 10.6507 14.4826C10.7058 14.1831 10.7778 13.9111 10.8666 13.6666L7.93332 10.7999Z"
        fill={color}
      />
    </svg>
  );
};

export default VisibilityOff;
